// extracted by mini-css-extract-plugin
export var base = "_26-0";
export var updateBanner = "_26-1";